import React from "react";
import { Button } from "../design/button";
import { useLocationDialog } from "../providers/LocationDialogProvider";

interface Props {
  caseId: string;
}

const CreateLocationButton: React.FC<Props> = ({ caseId }) => {
  const { openCreateDialog } = useLocationDialog();

  return (
    <Button type="button" onClick={() => openCreateDialog({ caseId })}>
      Create Location
    </Button>
  );
};

export default CreateLocationButton;
